"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[119],{

/***/ 9086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ ArticleCardTags; },
  "Z": function() { return /* binding */ latest_articles_ArticleCard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(1893);
// EXTERNAL MODULE: ./src/utils/Container.tsx
var Container = __webpack_require__(5084);
;// CONCATENATED MODULE: ./src/components/common/svg/common/Share.tsx

const Share = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: 17,
        height: 15,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M9.152 3.89V1.28c0-.226.086-.444.239-.604.153-.16.36-.25.577-.25.214 0 .42.09.571.247l5.715 5.987a.892.892 0 0 1 0 1.215l-5.715 5.987a.782.782 0 0 1-.886.178.826.826 0 0 1-.364-.313.884.884 0 0 1-.137-.472v-2.652h-.694a8.544 8.544 0 0 0-3.747.804 8.929 8.929 0 0 0-3.078 2.378.818.818 0 0 1-.407.302.781.781 0 0 1-.907-.322.884.884 0 0 1-.148-.51c0-7.8 6.597-9.135 8.98-9.366Zm-.694 4.986c.546-.002 1.091.035 1.632.11.194.032.37.134.497.29a.88.88 0 0 1 .197.558v1.36l3.74-3.926-3.74-3.926v1.36a.876.876 0 0 1-.239.605.798.798 0 0 1-.577.25c-.743 0-6.62.171-7.894 5.5a10.348 10.348 0 0 1 6.384-2.181Z",
            fill: "#fff"
        })
    });
/* harmony default export */ var common_Share = (Share);

// EXTERNAL MODULE: ./src/components/common/ui/SizedBox.tsx
var SizedBox = __webpack_require__(1680);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(2920);
;// CONCATENATED MODULE: ./src/components/landing/latest-articles/ArticleCard.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: flex-start;\n  cursor: pointer;\n  width: 100%;\n  min-width: 250px;\n  border-radius: ",
        ";\n  ",
        " {\n    width: 350px;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 201px;\n  position: relative;\n  img {\n    /* max-width: 201px; */\n    height: 201px;\n    object-fit: cover;\n    border-radius: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 10px 0px 0px 0px;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 19px;\n  min-height: 40px;\n  color: ",
        ";\n  ",
        " {\n    font-size: 16px;\n    line-height: 22px;\n  }\n\n  background: ",
        ";\n  -webkit-background-clip: ",
        ";\n  -webkit-text-fill-color: ",
        ";\n  background-clip: text;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 10px 0px 0px 0px;\n  font-weight: 300;\n  font-size: 14px;\n  line-height: 17px;\n  color: ",
        ";\n\n  overflow: hidden;\n   text-overflow: ellipsis;\n   display: -webkit-box;\n   -webkit-line-clamp: 3;\n           line-clamp: 3; \n   -webkit-box-orient: vertical;\n\n  ",
        " {\n    font-size: 16px;\n    line-height: 19px;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  color: ",
        ";\n  padding: 0 12px 0 8px;\n  font-weight: 400;\n  height: 30px;\n  font-size: 8px;\n  line-height: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  grid-gap: 0 8px;\n  img {\n    height: 18px !important;\n    width: 18px !important;\n    position: initial !important;\n  }\n  ",
        " {\n    font-size: 10px;\n    line-height: 12px;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 18px;\n  right: 19px;\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}








const ArticleCardContainer = (0,styled_components_browser_esm/* default */.ZP)(Container/* A7AColumn */.V2).withConfig({
    componentId: "sc-77fd9849-0"
})(_templateObject(), (props)=>props.theme.borderRadius, (props)=>props.theme.mediaQuery.tablet);
const ArticleCardImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-77fd9849-1"
})(_templateObject1(), (props)=>props.theme.borderRadius);
const ArticleCardTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-77fd9849-2"
})(_templateObject2(), (props)=>props.theme.colors.textColors[0], (props)=>props.theme.mediaQuery.tablet, (props)=>props.isActive ? props.theme.colors.accent : "inital", (props)=>props.isActive ? "text" : "inital", (props)=>props.isActive ? "transparent" : "inital");
const ArticleCardDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-77fd9849-3"
})(_templateObject3(), (props)=>props.theme.colors.textColors[0], (props)=>props.theme.mediaQuery.tablet);
const ArticleCardTags = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-77fd9849-4"
})(_templateObject4(), Container/* SquircleOutlined3 */.yI, (props)=>props.theme.colors.secondary2, (props)=>props.theme.mediaQuery.tablet);
const ShareIconContainer = (0,styled_components_browser_esm/* default */.ZP)(Container/* A7ACenteredRow */.as).withConfig({
    componentId: "sc-77fd9849-5"
})(_templateObject5());
const ArticleCard = (param)=>{
    let { id , image , title , description , tags , isActive , share , noRedirect  } = param;
    const handleShare = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        const data = {
            title: title,
            url: "https://a7alabs.com/article/".concat(id)
        };
        if ((navigator === null || navigator === void 0 ? void 0 : navigator.canShare) && navigator.canShare(data)) {
            navigator.share(data).then(()=>{}).catch((e)=>{});
        } else {
            navigator.clipboard.writeText("https://a7alabs.com/article/".concat(id));
            react_toastify_esm/* toast.success */.Am.success("Link copied to clipboard!");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: noRedirect ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArticleCardContainer, {
                isActive: isActive,
                style: {
                    cursor: "initial"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArticleCardImage, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: image,
                                alt: title,
                                fill: true,
                                loading: "lazy"
                            }),
                            share && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareIconContainer, {
                                onClick: handleShare,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Share, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCardTitle, {
                        isActive: isActive,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCardDescription, {
                        children: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SizedBox/* default */.Z, {
                        height: 20,
                        width: 0
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* A7ARow */.ml, {
                        style: {
                            gap: 10,
                            flexWrap: "wrap"
                        },
                        children: tags.map((tag, j)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(ArticleCardTags, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: tag.icon,
                                        alt: title,
                                        fill: true
                                    }),
                                    tag.name
                                ]
                            }, j))
                    })
                ]
            }, id)
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/article/".concat(id),
                legacyBehavior: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArticleCardContainer, {
                    isActive: isActive,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArticleCardImage, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: image,
                                    alt: title,
                                    fill: true
                                }),
                                share && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareIconContainer, {
                                    onClick: handleShare,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Share, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCardTitle, {
                            isActive: isActive,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCardDescription, {
                            children: description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SizedBox/* default */.Z, {
                            height: 20,
                            width: 0
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* A7ARow */.ml, {
                            style: {
                                gap: 10,
                                flexWrap: "wrap"
                            },
                            children: tags.map((tag, j)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(ArticleCardTags, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: tag.icon,
                                            alt: title,
                                            fill: true
                                        }),
                                        tag.name
                                    ]
                                }, j))
                        })
                    ]
                }, id)
            })
        })
    });
};
/* harmony default export */ var latest_articles_ArticleCard = (ArticleCard);


/***/ }),

/***/ 119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ ArticleCardWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9746);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);
/* harmony import */ var react_whirlpool__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4990);
/* harmony import */ var react_whirlpool_dist_cjs_component_SimpleCarousel_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9541);
/* harmony import */ var react_whirlpool_dist_cjs_component_SimpleCarousel_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_whirlpool_dist_cjs_component_SimpleCarousel_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(1893);
/* harmony import */ var _gql_articles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9764);
/* harmony import */ var _lib_apollo__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7461);
/* harmony import */ var _utils_useMediaQuery__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8308);
/* harmony import */ var _common_button__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1733);
/* harmony import */ var _common_svg_common_RightArrow__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(459);
/* harmony import */ var _common_ui_SectionWrapper__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(6731);
/* harmony import */ var _common_ui_SizedBox__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(1680);
/* harmony import */ var _ArticleCard__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9086);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: ",
        ";\n  margin-top: 30px;\n  justify-content: flex-start;\n  gap: 30px;\n  max-width: 100%;\n  margin-bottom: 16px;\n  ",
        " {\n    margin-top: 60px;\n    flex-direction: row;\n    margin-bottom: 60px;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}















const ArticleCardWrapper = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5f67d969-0"
})(_templateObject(), (props)=>props.theme.constrainedMargin, (props)=>props.theme.mediaQuery.tablet);
const LatestArticles = ()=>// { onView }: ISectionProps
{
    // const isMobile = useMediaQuery("(max-width: 400px)");
    // const {ref, inView } = useInView({
    //   rootMargin: "0px 2000px 500px 0px",
    //   threshold: 0.4,
    // });
    // useEffect(() => {
    //   if (inView === true) {
    //     onView(6);
    //     console.log(inView);
    //     console.log("Projects In view");
    //   }
    // }, [inView, onView]);
    const isMobile = (0,_utils_useMediaQuery__WEBPACK_IMPORTED_MODULE_9__/* .useMediaQuery */ .a)("(max-width: 766px)");
    const [activeIndex, setActiveIndex] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0);
    const [latestArticles, setLatestArticles] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]);
    const simpleCarouselRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)();
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("landing");
    const handleFetchLatestArticles = async ()=>{
        try {
            const { data  } = await _lib_apollo__WEBPACK_IMPORTED_MODULE_8__/* ["default"].query */ .Z.query({
                query: (0,_gql_articles__WEBPACK_IMPORTED_MODULE_7__/* .getLatestArticles */ .gg)()
            });
            console.log(data);
            setLatestArticles(data.blogs.data);
        } catch (e) {}
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        handleFetchLatestArticles();
    }, []);
    if (!latestArticles || latestArticles.length == 0) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_common_ui_SectionWrapper__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
            id: "articles",
            carouselButtons: !isMobile,
            heading: t("articles.0.latestArticlesTitle"),
            description: t("articles.1.latestArticlesDescription"),
            leftButtonOnClick: ()=>{
                simpleCarouselRef.current && simpleCarouselRef.current.handlePrevEvent();
            },
            rightButtonOnClick: ()=>{
                simpleCarouselRef.current && simpleCarouselRef.current.handleNextEvent();
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ArticleCardWrapper, {
                    children: !isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_whirlpool__WEBPACK_IMPORTED_MODULE_5__/* .SimpleCarousel */ .P, {
                            isHorizontal: true,
                            gap: 30,
                            autoPlay: false,
                            hideInitGap: false,
                            minHeight: "154px",
                            ref: simpleCarouselRef,
                            hideArrows: true,
                            onActiveIndexUpdate: (index)=>setActiveIndex(index),
                            children: latestArticles === null || latestArticles === void 0 ? void 0 : latestArticles.map((article, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ArticleCard__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                        isActive: i === activeIndex,
                                        id: article.attributes.article_uid,
                                        image: "".concat("https://blogs-api.a7alabs.com").concat(article.attributes.cover_img.data.attributes.url),
                                        title: article.attributes.title,
                                        description: article.attributes.subtitle,
                                        tags: article.attributes.tags.data.map((c)=>{
                                            return {
                                                name: c.attributes.name,
                                                icon: "".concat("https://blogs-api.a7alabs.com").concat(c.attributes.icon.data.attributes.url)
                                            };
                                        }),
                                        share: true
                                    }, article.id)
                                }, i))
                        })
                    }) : latestArticles === null || latestArticles === void 0 ? void 0 : latestArticles.map((article, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ArticleCard__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    isActive: false,
                                    id: article.attributes.article_uid,
                                    image: "".concat("https://blogs-api.a7alabs.com").concat(article.attributes.cover_img.data.attributes.url),
                                    title: article.attributes.title,
                                    description: article.attributes.subtitle,
                                    tags: article.attributes.tags.data.map((c)=>{
                                        return {
                                            name: c.attributes.name,
                                            icon: "".concat("https://blogs-api.a7alabs.com").concat(c.attributes.icon.data.attributes.url)
                                        };
                                    }),
                                    share: true
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_common_ui_SizedBox__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                    height: 24,
                                    width: 0
                                })
                            ]
                        }, i))
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                    href: "/articles",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_common_button__WEBPACK_IMPORTED_MODULE_10__/* .GenericButton */ .M, {
                        text: t("articles.2.latestArticlesButton"),
                        height: 50,
                        width: 180,
                        isFullWidth: false,
                        isDisabled: false,
                        isProcessing: false,
                        onClick: ()=>{},
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_common_ui_SizedBox__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                width: 18,
                                height: 0
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_common_svg_common_RightArrow__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
                        ]
                    })
                })
            ]
        })
    });
};
// export async function getStaticProps() {
//   try {
//     const { data } = await client.query({
//       query: getLatestArticles(),
//     });
//     console.log(data);
//     return {
//       props: {
//         blogs: data.blogs,
//       },
//     };
//   } catch (e) {
//     return {
//       props: {},
//     };
//   }
// }
/* harmony default export */ __webpack_exports__["Z"] = (LatestArticles);


/***/ }),

/***/ 9764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Zz": function() { return /* binding */ getArticles; },
/* harmony export */   "gg": function() { return /* binding */ getLatestArticles; }
/* harmony export */ });
/* unused harmony exports getCategories, getArticleByUid, getSimilarArticles */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1621);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query {\n    categories {\n      data {\n        attributes {\n          name\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  # Write your query or mutation here\n  query {\n    blogs(pagination: { start: 0, limit: 10 }, sort: "createdAt:desc") {\n      data {\n        attributes {\n          title\n          createdAt\n          subtitle\n          article_uid\n          body\n          cover_img {\n            data {\n              attributes {\n                url\n              }\n            }\n          }\n          tags {\n            data {\n              attributes {\n                name\n                icon {\n                  data {\n                    attributes {\n                      url\n                    }\n                  }\n                }\n              }\n            }\n          }\n          category {\n            data {\n              attributes {\n                name\n                icon {\n                  data {\n                    attributes {\n                      url\n                    }\n                  }\n                }\n              }\n            }\n          }\n          author {\n            data {\n              attributes {\n                username\n                avatar {\n                  data {\n                    attributes {\n                      url\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n'
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  query {\n    blogs(sort: "createdAt:desc",\n    filters: { category: { name: { in: [',
        "] } } }\n    ) {\n      data {\n        attributes {\n          title\n          createdAt\n          subtitle\n          article_uid\n          body\n          cover_img {\n            data {\n              attributes {\n                url\n              }\n            }\n          }\n          tags {\n            data {\n              attributes {\n                name\n                icon {\n                  data {\n                    attributes {\n                      url\n                    }\n                  }\n                }\n              }\n            }\n          }\n          category {\n            data {\n              attributes {\n                name\n                icon {\n                  data {\n                    attributes {\n                      url\n                    }\n                  }\n                }\n              }\n            }\n          }\n          author {\n            data {\n              attributes {\n                username\n                avatar {\n                  data {\n                    attributes {\n                      url\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        '\n  query {\n    blogs(filters: { article_uid: { eq: "',
        '" } }) {\n      data {\n        attributes {\n          title\n          createdAt\n          subtitle\n          article_uid\n          body\n          cover_img {\n            data {\n              attributes {\n                url\n              }\n            }\n          }\n          tags {\n            data {\n              attributes {\n                name\n                icon {\n                  data {\n                    attributes {\n                      url\n                    }\n                  }\n                }\n              }\n            }\n          }\n          category {\n            data {\n              attributes {\n                name\n                icon {\n                  data {\n                    attributes {\n                      url\n                    }\n                  }\n                }\n              }\n            }\n          }\n          author {\n            data {\n              attributes {\n                username\n                avatar {\n                  data {\n                    attributes {\n                      url\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n'
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal([
        "\n  # Write your query or mutation here\n  query {\n    blogs(\n      filters: { tags: { name: { in: [",
        '] } }, article_uid: {ne: "',
        '"} }\n      pagination: { start: 0, limit: 6 },\n      sort: "createdAt:desc"\n    ) {\n      data {\n        attributes {\n          title\n          createdAt\n          subtitle\n          article_uid\n          body\n          cover_img {\n            data {\n              attributes {\n                url\n              }\n            }\n          }\n          tags {\n            data {\n              attributes {\n                name\n                icon {\n                  data {\n                    attributes {\n                      url\n                    }\n                  }\n                }\n              }\n            }\n          }\n          category {\n            data {\n              attributes {\n                name\n                icon {\n                  data {\n                    attributes {\n                      url\n                    }\n                  }\n                }\n              }\n            }\n          }\n          author {\n            data {\n              attributes {\n                username\n                avatar {\n                  data {\n                    attributes {\n                      url\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n'
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}

const getCategories = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
const getLatestArticles = ()=>(0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());
const getArticles = (categories)=>(0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2(), categories);
const getArticleByUid = (uid)=>gql(_templateObject3(), uid.toString());
const getSimilarArticles = (tags, uid)=>gql(_templateObject4(), tags, uid);


/***/ })

}]);